import React from 'react'
import { DataGrid } from 'Common/CusomReactGrid/CustomDataGrid'
import moment from 'moment-mini'

const EligibilityLogGrid = ({ rows, handleLogsShowRow, handlePageChange, handlePerRowsChange, pagination }) => {



    const columns = [
        { name: "Date Requested", key: "eligibilityDate", formatter: ({ row }) => <span>{moment(row.addedDate).format('MM/DD/YYYY HH:mm:ss')}</span> },
        { name: "Patient Name", key: "patient", },
        { name: "Policy Number", key: "policyNumber", },
        { name: "Payer", key: "payerName", },
        { name: "Provider", key: "provider", },
        { name: "Requested by", key: "requestedByUserName", },
        {
            name: "Status", key: "inActive",
            formatter: ({ row }) => (
                <div className={`status-pill ${row.eligibilityStatus === "Completed" ? "status-pill-paid" : "status-pill-failed"}`}>
                    {row.eligibilityStatus}
                </div>
            )
        },
       

    ]
    return (
       <div className='flex h-full'>
         <DataGrid
            columns={columns}
            rows={rows}
            contentBasedHeight={true}
            rowClass={()=>'cursor-pointer'}
            pagination={pagination}
            manualPagination={true}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            onRowClick={(row) => handleLogsShowRow(row.id)}
           
        />
       </div>
    )
}

export default EligibilityLogGrid